import { Component, OnInit, Input, Output } from '@angular/core';

@Component({
  selector: 'app-log-prestation',
  templateUrl: './log.component.html',
  styleUrls: ['./log.component.css']
})
export class LogComponent implements OnInit {

  @Input() rows;
  @Input() message;
  @Input() logModifEtendu;
  @Input() logChorus;
  isEcofact: Boolean = false;

  constructor() { }

  ngOnInit() {
    console.log(this.logModifEtendu);
    console.log(this.logChorus);
    const url = window.location.href
    if (url.includes('/ecofact')) {
      this.isEcofact = true;
    } else {
      this.isEcofact = false;
    }
  }

}
